export type Response<T = void> = {
  status: EResponseStatus;
  message: string;
  data?: T;
  error?: unknown;
  error_code?: number;
};

export enum EEnvironment {
  PRODUCTION = "production",
  DEV = "development"
}

// INFO: Represents the status string of a successful HTTP response
export enum EResponseStatus {
  SUCCESS = 'success',
  ERROR = 'failure',
};
